module.exports = __webpack_public_path__ + "static/media/IMG_3544.92522e94.jpg";